import React, { useState } from 'react';
import { DropdownToggle, Dropdown, DropdownMenu, DropdownItem, UncontrolledTooltip } from 'reactstrap';
import ApplicationCard from './ApplicationCard';
import { useTranslation } from 'react-i18next';
import Avatar from 'react-avatar';

const ApplicationColumn = ({
  column,
  columnId,
  provided,
  refreshStatus,
  toggleIsConfigureEmailModalOpen,
  toggleIsRenameKanbanModalOpen,
  toggleIsConfigureAutomatizationsModalOpen,
  toggleAssignedUserModal,
  setSelectedColumn,
  parsedKanbanSettings,
  setIsDroppedToFalse,
  kanbanResponsibles,
}) => {
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  const { t } = useTranslation();

  const emailConfigClicked = () => {
    toggleIsConfigureEmailModalOpen();
    setSelectedColumn(column);
  };

  const renameKanbanColumnClicked = () => {
    setSelectedColumn(column);
    toggleIsRenameKanbanModalOpen();
  };

  const configureKanbanColumnClicked = () => {
    setSelectedColumn(column);
    toggleIsConfigureAutomatizationsModalOpen();
  };

  const addResponsibleClicked = () => {
    setSelectedColumn(column);
    toggleAssignedUserModal();
  };

  return (
    <div
      className={column.tag === 'recruiting' ? 'recruiting-column' : 'onboarding-column'}
      ref={provided.innerRef}
      {...provided.droppableProps}
      style={{
        maxWidth: '250px',
      }}
    >
      <div className="d-flex justify-content-between">
        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <h3>{column.title}</h3>
        </div>
        <Dropdown isOpen={isDropDownOpen} toggle={() => setIsDropDownOpen((prev) => !prev)}>
          <DropdownToggle color="link">
            <em
              id={`kanbanColumn-${columnId}`}
              className={
                column.sendAutomatedEmail === true
                  ? 'fa icon-settings fa-lg font-weight-bold text-green far icon-hover-effect-no-color'
                  : 'fa icon-settings fa-lg text-muted far icon-hover-effect-no-color'
              }
            />
            {/* <UncontrolledTooltip delay={{ show: 100, hide: 0 }} placement="top" target={`kanbanColumn-${columnId}`}>
              {column.sendAutomatedEmail === true
                ? t('kanban.AUTOMATED_EMAIL_SENT')
                : t('kanban.AUTOMATED_EMAIL_NOT_SENT')}
            </UncontrolledTooltip> */}
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-right-forced animated fadeInLeft">
            <DropdownItem>
              <div
                id={`column-${columnId}`}
                className="d-flex align-items-center cursor-pointer"
                onClick={() => renameKanbanColumnClicked()}
              >
                <small>
                  <i className="fa-2x mr-2 mt-1 fas icon-pencil" />
                </small>
                {t('kanban.RENAME')}
              </div>
            </DropdownItem>
            <DropdownItem>
              <div
                id={`column-${columnId}`}
                className="d-flex align-items-center cursor-pointer"
                onClick={() => addResponsibleClicked()}
              >
                <small>
                  <i className="fa-2x mr-2 fas icon-user-follow" />
                </small>
                {t('kanban.MANAGE_RESPONSIBLE')}
              </div>
            </DropdownItem>
            <DropdownItem disabled>
              <div
                id={`column-${columnId}`}
                className="d-flex align-items-center cursor-pointer"
                onClick={() => emailConfigClicked()}
              >
                <small>
                  <i className="fa-2x mr-2 icon-envelope" />
                </small>
                {t('kanban.EMAIL_CONFIGURATION')}
              </div>
            </DropdownItem>
            <DropdownItem disabled>
              <div
                id={`column-${columnId}`}
                className="d-flex align-items-center cursor-pointer"
                onClick={() => configureKanbanColumnClicked()}
              >
                <small>
                  <i className="fa-2x mr-2 icon-earphones-alt" />
                </small>
                {t('kanban.FOLLOW_UP')}
              </div>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      {kanbanResponsibles && kanbanResponsibles.length > 0 && (
        <div className="d-flex flex-wrap">
          {kanbanResponsibles.map((responsible) => (
            <Avatar
              key={responsible.id}
              name={responsible.firstName + ' ' + responsible.lastName}
              size={24}
              round={true}
              className="mr-1"
              src={responsible.photoUrl}
            />
          ))}
        </div>
      )}
      <br />
      {column.items.map((item, index) => (
        <ApplicationCard
          key={item.applicationId}
          item={item}
          index={index}
          refreshStatus={refreshStatus}
          parsedKanbanSettings={parsedKanbanSettings}
          column={column}
          setIsDroppedToFalse={setIsDroppedToFalse}
        />
      ))}
      {provided.placeholder}
    </div>
  );
};
export default ApplicationColumn;
